import { auth } from "../firebase/firebase";

export const getUserAuthorizationHeader = async (): Promise<string | null> => {
  try {
    const token = await auth.currentUser?.getIdToken();
    if (!token) {
      return null;
    }
    return `Bearer ${token}`;
  } catch (error) {
    console.error("[AuthHeaders] Failed to get Firebase ID token:", error);
    return null;
  }
};
